module.exports = __webpack_public_path__ + "media/icons/heart_2d-a1450edb.svg";